import { FileType } from "../../../../models";
import { VerifierProjectCardWithTabsTemplate } from "../../../../templates/Verifier/VerifierProjectCardWithTabsTemplate";
import { useProject } from "./useProject";

const Project = (): JSX.Element => {
  const { projectDetails, backButtonText, handleBackClick, tabsList } = useProject();

  return (
    <VerifierProjectCardWithTabsTemplate
      activeElement="Projects"
      pageTitle={projectDetails?.displayName}
      projectCode={projectDetails?.standard.displayName}
      projectDeveloper={projectDetails?.developer.displayName}
      projectDeveloperIcon={projectDetails?.developer.files.find((f) => f.type === FileType.SmallLogo)?.file.url}
      projectStatus={projectDetails?.status}
      tabsList={tabsList}
      backButtonText={backButtonText}
      handleBackClick={handleBackClick}
    />
  );
};

export default Project;
